const menuHelper = {
  getMenuTab: (_state, menuName) => {
    let menuTab = null;
    _state.menuTree.forEach((menu) => {
      if (menu.name === menuName || menu.title === menuName) {
        menuTab = menu;
      } else {
        menu.subMenu?.forEach((subMenu) => {
          if (subMenu.name === menuName || subMenu.title === menuName) {
            menuTab = subMenu;
          }
        });
      }
    });
    return menuTab;
  }
};

const initState = {
  menuShow: true,
  activeName: '',
  menuTree: [
    {
      name: 'homepage',
      title: '首页',
      show: false,
      subMenu: []
    },
    {
      name: 'accout',
      title: '我的账户',
      IconType: 'android-contacts',
      show: false,
      subMenu: [
        {
          name: 'capital-manage',
          title: '账户管理',
          show: false
        },
        {
          name: 'accout-manage',
          title: '账号管理',
          show: false
        }
      ]
    },
    {
      name: 'qualification',
      title: '资质管理',
      IconType: 'ios-bookmarks-outline',
      show: false,
      subMenu: [
        {
          name: 'qualification-config',
          title: '首营资料设置',
          show: false
        },
        {
          name: 'qualification-company',
          title: '我的企业资质',
          show: false
        },
        {
          name: 'qualification-agreement',
          title: '我的协议',
          show: false
        },
        {
          name: 'qualification-product',
          title: '我的品种资质',
          show: false
        },
      ]
    },
    {
      name: 'esign',
      title: '资料发送',
      IconType: 'ios-email-outline',
      show: false,
      subMenu: [
        {
          name: 'esign-add',
          title: '新建资料',
          show: false
        },
        {
          name: 'esign-send',
          title: '签章发送',
          show: false
        }
      ]
    },
    {
      name: 'record',
      title: '交换记录',
      IconType: 'ios-email-outline',
      // 一直显示,不受权限控制
      alwaysShow: true,
      show: false,
      subMenu: [
        {
          name: 'verify-seal',
          title: '验证电子签章',
          alwaysShow: true
        },
        {
          name: 'record-receive',
          title: '收件箱',
          show: false
        },
        {
          name: 'record-send',
          title: '发件箱',
          show: false
        }
      ]
    },
    {
      name: 'help-center',
      title: '帮助中心',
      alwaysShow: true
    },
  ],
  menus: [], // 菜单字典
  auth: [] // 功能权限列表
};

const getters = {
  getActiveName(state) {
    return state.activeName;
  }
};

const mutations = {
  updateMenuConfig(state, { menuName, show }) {
    menuHelper.getMenuTab(state, menuName).show = show;
  },
  updateActiveName(state, activeName) {
    state.activeName = activeName;
  },
  updateMenuShow(state, show) {
    if (show !== undefined) state.menuShow = show;
    else {
      state.menuShow = !state.menuShow;
    }
  },
  updateAllMenu(state, menus) {
    state.menus = menus;
  },
  updateAllMenuVisible(state) {
    state.menuTree.forEach((menu) => {
      menu.show = true;
      menu.subMenu?.forEach((sub) => {
        sub.show = true;
      });
    });
  },
  updateMenuVisible(state, menuIds) {
    const menuNames = state.menus.map((item) => menuIds.includes(item.menuId) && item.menuName)
      .filter((item) => typeof (item) === 'string');
    menuNames.forEach((name) => {
      const menu = menuHelper.getMenuTab(state, name);
      if (menu) menu.show = true;
    });
  },
  // 是否显示对应的权限按钮
  updateButtonVisible(state, menuIds) {
    const fnType = 1; // 功能
    const fns = state.menus.filter((menu) => menu.menuType === fnType);
    state.auth = fns.map((fn) => menuIds.includes(fn.menuId) && fn.menuName)
      .filter((fn) => typeof (fn) === 'string');
  }
};

export default {
  state: initState,
  getters,
  mutations
};
